module.exports = __webpack_public_path__ + "static/media/tj.224f1366.png";